import { useWatch } from 'react-hook-form';
import { FormField } from 'v5/design-system/Form';
import { TernaryToggle } from 'v5/design-system/TernaryToggle';
import { useFieldContext } from '../FieldContext';
import { EmptyField } from './EmptyField';
import { FieldControlBase } from './FieldControlBase';
import type { FieldFrameSpec, FieldPartProps } from './fieldComponent.types';

/** Yes / not set / no toggle over `boolean | null`. */
export function BooleanField({
  spec,
  path,
  hideLabel
}: FieldPartProps<FieldFrameSpec>) {
  const ctx = useFieldContext();
  const readOnly = ctx.mode === 'display';
  const checked: boolean | null = useWatch({ name: path }) ?? null;

  if (readOnly && checked === null) {
    return <EmptyField spec={spec} path={path} hideLabel={hideLabel} />;
  }

  return (
    <FormField
      name={path}
      render={({ field }) => (
        <FieldControlBase spec={spec} hideLabel={hideLabel}>
          <TernaryToggle
            size="xs"
            value={field.value ?? null}
            onChange={field.onChange}
            onBlur={field.onBlur}
            name={field.name}
            readOnly={readOnly}
            ref={field.ref}
          />
        </FieldControlBase>
      )}
    />
  );
}
